"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.BadgeWrapper = styled_1.default.div `
  display: flex;
  flex-wrap: wrap;
`;
//# sourceMappingURL=styles.js.map